<p-dialog
  [visible]="visible()"
  (visibleChange)="onVisibilityChange($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!isSaving()"
  [header]="'DOCUMENT_MANAGEMENT.NEW_FOLDER' | translate"
  styleClass="new-folder-dialog">
  <div class="new-folder-dialog__body">
    <label for="new-folder-name" class="new-folder-dialog__label">
      {{ 'DOCUMENT_MANAGEMENT.FOLDER_NAME' | translate }}
    </label>
    <input
      #nameInput
      pInputText
      id="new-folder-name"
      class="new-folder-dialog__input"
      [formField]="newFolderForm.name"
      [placeholder]="'DOCUMENT_MANAGEMENT.FOLDER_NAME_PLACEHOLDER' | translate"
      [attr.aria-invalid]="
        newFolderForm.name().touched() && newFolderForm.name().invalid() ? true : null
      "
      [attr.aria-describedby]="newFolderForm.name().invalid() ? 'new-folder-name-error' : null"
      (keydown.enter)="onSave()" />
    @if (newFolderForm.name().touched() && newFolderForm.name().invalid()) {
      <small id="new-folder-name-error" class="new-folder-dialog__error">
        {{ newFolderForm.name().errors()[0]?.message ?? '' | translate }}
      </small>
    }
    @if (errorMessage()) {
      <small class="new-folder-dialog__error">{{ errorMessage() }}</small>
    }
  </div>
  <ng-template pTemplate="footer">
    <p-button
      [label]="'GENERAL.CANCEL' | translate"
      severity="secondary"
      [text]="true"
      [disabled]="isSaving()"
      (onClick)="onCancel()" />
    <p-button
      [label]="'GENERAL.CREATE' | translate"
      severity="primary"
      [loading]="isSaving()"
      [disabled]="newFolderForm().invalid() || isSaving()"
      (onClick)="onSave()" />
  </ng-template>
</p-dialog>
